const errorCodesMapping = {
    INSUFFICIENT_FUNDS: 'Insufficient funds for this transaction.',
};
const transactionErrorMessage = (error) => {
    const { code } = error;
    const defaultMessage = 'Something went wrong.';
    if (!code)
        return defaultMessage;
    return errorCodesMapping[code] || defaultMessage;
};

export { transactionErrorMessage };
